import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllPermissions = createAsyncThunk('permissions/getAllPermissions', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/permissions`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// Assign Role Permission == Create New Main Menu
export const createNewPermission = createAsyncThunk(
  'permissions/createNewPermission',
  async ({ permission_name }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/permissions`, { permission_name });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// Assign Role Permission == Create New Sub Menu
export const assignRolePermission = createAsyncThunk('permissions/assignRolePermission', async (payload, thunkAPI) => {
  const { role_id, permission_action } = payload;

  try {
    const response = await axiosInstance.post(`/role-permissions`, { role_id, permission_action });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateAssignRolePermission = createAsyncThunk(
  'permissions/updateAssignRolePermission',
  async (payload, thunkAPI) => {
    const { role_id, action_permission } = payload;

    try {
      const response = await axiosInstance.put(`/role-permissions/${role_id}`, { role_id, action_permission });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getRolePermissionsById = createAsyncThunk('permissions/getRolePermissionsById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/roles/${id}/permissions`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
